import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import type { ICharacter } from '@rpgc-ai/shared-interfaces/interfaces/characters.interface';
import type { IChatWithDetails } from '@rpgc-ai/shared-interfaces/interfaces/chat.interface';
import type { IPublicProfile } from '@rpgc-ai/shared-interfaces/interfaces/public-profile.interface';

import type { Observable } from 'rxjs';

import { SessionService } from '../auth/session.service';
import { PUBLIC_API_REQUEST, SKIP_AUTH_ERROR_HANDLING, SKIP_GLOBAL_ERROR_NOTIFICATION } from '../auth/skip-global-error-notification.token';

/**
 * Plain one-shot reads for the SEO resolvers: the feature services load the same entities through
 * store-writing resources, which a resolver must not drive.
 */
@Injectable({ providedIn: 'root' })
export class SeoDataService {
  readonly #http = inject(HttpClient);
  readonly #sessionService = inject(SessionService);

  getCharacter(characterSlug: string, authorSlug?: string): Observable<ICharacter> {
    const characterUrl = authorSlug ? `${authorSlug}/${characterSlug}` : characterSlug;
    const context = (this.#sessionService.isAuthenticated() === true
      ? new HttpContext().set(SKIP_AUTH_ERROR_HANDLING, true)
      : new HttpContext().set(PUBLIC_API_REQUEST, true)
    ).set(SKIP_GLOBAL_ERROR_NOTIFICATION, true);

    return this.#http.get<ICharacter>(`characters/${characterUrl}`, { context });
  }

  getChat(chatId: string): Observable<IChatWithDetails> {
    return this.#http.get<IChatWithDetails>(`chats/${chatId}`);
  }

  getPublicProfile(profileId: string): Observable<IPublicProfile> {
    return this.#http.get<IPublicProfile>(`profile/${profileId}`);
  }
}
